/* eslint-disable react/jsx-pascal-case */
import { Row, Col, Modal, Button, Alert, Card } from "../../ui/ot";

import React, { useEffect, useRef, useState } from "react";
import { useComponent } from "../controller/component_controller";
import { DragHandleDots2Icon, TrashIcon } from "@radix-ui/react-icons"
import {
    Sortable,
    SortableDragHandle,
    SortableItem,
} from "../../ui/sortable"
const PageFrontendRowComponentSortModal = ({
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => { },
    onFinish = () => { },
    frontend_component_blog_type_data,
    setPageContainerData = () => { }
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "修改",
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const showModal = () => {
        // setFormReloadCount((pre) => pre + 1);
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };
    const { ComponentData, getComponentData } = useComponent({
        onFinish: () => { },
        onBefore: () => { },
    });
    useEffect(() => {
        getComponentData({});
    }, []);
    useEffect(() => {
        // setFormReloadCount((pre) => pre + 1);
    }, [propsOpen]);

    return (
        <>
            {propsOpen === null && (
                <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    onClick={showModal}
                >
                    {`模板排序`}
                </Button>

            )}

            <Modal
                style={{ top: 10 }}
                title={`模板排序`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                contentStyle={{
                    padding: 16,
                }}
                width={800}
                okText={"送出"}
                cancelText={"取消"}
                footer={
                    <Button
                        onClick={() => {
                            handleCancel();
                        }}
                    >
                        關閉
                    </Button>
                }
            >
                <Row
                    style={{
                        minHeight: "80vh",
                        maxHeight: "80vh",
                        // overflowX: "scroll",
                        overflowY: "scroll",
                    }}
                >
                    <Col span={24}>
                        <SortFrontendComponentBlogTypeData
                            defaultSortDatas={frontend_component_blog_type_data || []}
                            onSortEnd={(value) => { setPageContainerData(value) }}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

const SortFrontendComponentBlogTypeData = ({
    defaultSortDatas = [],
    onSortEnd = () => { },
    rowkey = "frontend_row_id"
}) => {
    const [sortDatas, setSortDatas] = useState(defaultSortDatas ? defaultSortDatas : [])
    const tempCount = useRef(1)
    const moveItem = (arr, fromIndex, toIndex) => {
        if (fromIndex >= arr.length || fromIndex < 0 || toIndex >= arr.length || toIndex < 0) {
            return arr;
        }
        const [item] = arr.splice(fromIndex, 1); // 移除指定索引的元素
        arr.splice(toIndex, 0, item); // 在目標索引插入該元素
        arr = arr.map((element, index) => {
            return {
                ...element,
                frontend_row_index: index
            }
        })
        return arr;
    }
    const addItemsId = (arr, rowKey) => {
        console.log({
            arr
        })
        return arr.map((value) => {
            if (!!value[rowKey]) {
                return {
                    ...value,
                    id: value[rowKey]
                }
            }
            else if (!value[rowKey] && !value?.id) {
                tempCount.current = tempCount.current + 1
                return {
                    ...value,
                    id: `${rowKey}${value?.frontend_row_index}`
                }
            }

            else if (!value[rowKey] && value?.id) {
                return {
                    ...value,
                }

            }

        })
    }

    return <Row>
        <Col span={24}>
            <Row>
                <Col span={24}>
                    <Sortable
                        value={addItemsId(defaultSortDatas || sortDatas, 'frontend_row_id')}
                        onMove={({ activeIndex, overIndex }) => {
                            let oldValue = defaultSortDatas ? [...defaultSortDatas] : [...sortDatas]
                            let sortItem = moveItem(oldValue, activeIndex, overIndex)
                            setSortDatas(sortItem)
                            onSortEnd(sortItem)
                        }}
                        overlay={
                            <Row>
                                <Col span={24}>
                                    <Alert type='warning' />
                                </Col>
                            </Row>
                        }
                    >
                        <Row>
                            <Col span={24}>
                                <Row>
                                    {(addItemsId(defaultSortDatas || sortDatas, 'frontend_row_id')).map((field, index) => (
                                        <SortableItem key={field?.id} value={field?.id} asChild>
                                            <Col span={24}>
                                                <Alert
                                                    showIcon={true}
                                                    icon={<SortableDragHandle
                                                        variant="outline"
                                                        size="icon"
                                                        className="size-8 shrink-0"
                                                    >
                                                        <DragHandleDots2Icon
                                                            className="size-4"
                                                            aria-hidden="true"
                                                        />
                                                    </SortableDragHandle>}
                                                    message={(field.page_frontend_row_data || []).map((page_frontend_row_data) => (
                                                        (page_frontend_row_data?.frontend_row_frontend_column_data || []).map((frontend_row_frontend_column_data) => {
                                                            console.log({
                                                                frontend_row_frontend_column_data
                                                            })
                                                            if (frontend_row_frontend_column_data?.frontend_column_frontend_component_blog_type_data.length > 0) {

                                                                return (frontend_row_frontend_column_data?.frontend_column_frontend_component_blog_type_data || []).map((frontend_column_frontend_component_blog_type_data) => {
                                                                    return <>標題名稱： {frontend_column_frontend_component_blog_type_data?.blog_type_name || '-'}</>
                                                                })
                                                            }
                                                            else {
                                                                return <>模板名稱： {frontend_row_frontend_column_data?.frontend_component_name || '-'}</>
                                                            }

                                                        })
                                                    ))}
                                                >
                                                    {/* <Row>
                                            <Col>
                                                <SortableDragHandle
                                                    variant="outline"
                                                    size="icon"
                                                    className="size-8 shrink-0"
                                                >
                                                    <DragHandleDots2Icon
                                                        className="size-4"
                                                        aria-hidden="true"
                                                    />
                                                </SortableDragHandle>
                                            </Col>
                                            <Col>
                                                {
                                                    (field.page_frontend_row_data || []).map((page_frontend_row_data) => (
                                                        (page_frontend_row_data.frontend_row_frontend_column_data || []).map((frontend_row_frontend_column_data) => (
                                                            (frontend_row_frontend_column_data.frontend_column_frontend_component_blog_type_data || []).map((frontend_column_frontend_component_blog_type_data) => {
                                                                return <>模板名稱： {frontend_column_frontend_component_blog_type_data?.blog_type_name}</>
                                                            })
                                                        ))
                                                    ))
                                                }
                                            </Col>
                                        </Row> */}
                                                </Alert>
                                            </Col>
                                        </SortableItem>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Sortable>
                </Col>
            </Row>


        </Col>
    </Row>
}
export default PageFrontendRowComponentSortModal;
